import EcoStationsIcon from './component'

export default EcoStationsIcon
